import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
	selector: 'app-location-basic',
	templateUrl: './location-basic.component.html',
	styleUrls: ['./location-basic.component.css'],
})
export class LocationBasicComponent implements OnChanges {
	@Input() data: any;
	@Input() editable = false;
	@Input() locations: [];
	@Output() dataChanged = new EventEmitter();
	locationsKinds: Array<any> = [
		{ value: 'CR', name: 'Państwo' },
		{ value: 'RG', name: 'Region' },
		{ value: 'CT', name: 'Miasto' },
	];

	isEmptyName = false;
	isEmptyCode = false;
	isCountry: boolean;

	ngOnChanges() {
		this.countryCheck();
	}

	countryCheck() {
		this.isCountry = this.data.locationKind === 'CR';
	}

	checkForm() {
		if (this.data.name === '') {
			this.isEmptyName = true;
		} else {
			this.isEmptyName = false;
		}
		if (this.data.code === '') {
			this.isEmptyCode = true;
		} else {
			this.isEmptyCode = false;
		}

		this.data.code = this.data.code.toUpperCase();
	}
}
